import { APP_CONFIG } from "app.config";
export const SWITCH_APP_URL = `${ APP_CONFIG.HOST_NAME}api/switchApp`;
// export const SWITCH_APP_URL = "https://xplatform-api-uat.a4b.vn/api/switchApp";